var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.vin)?_c('div',{staticClass:"tabs is-boxed"},[_c('ul',[_c('li',{class:{
          'is-active':
            _vm.active === 'MarketOverview' && _vm.permissions.similarListingExplorer
        }},[_c('a',{on:{"click":function($event){return _vm.toggleContent('MarketOverview')}}},[_c('span',[_vm._v("Market overview")])])]),_c('li',{class:{
          'is-active': _vm.active === 'VehicleInfoTimeline'
        }},[_c('a',{on:{"click":function($event){return _vm.toggleContent('VehicleInfoTimeline')}}},[_c('span',[_vm._v("Vehicle info & timeline")])])])])]):_vm._e(),_c('div',{staticClass:"is-fullheight"},[_c(_vm.active,_vm._b({tag:"component",attrs:{"load":_vm.timeline}},'component',{ vrm: _vm.vrm },false))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }